import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PolicyService } from 'app/services/policy-service';
import { AuthService } from 'app/security/auth.service';
import { ActionItem } from '../../actions-dropdown/actions-dropdown.component';

interface CardIcon { branchType?: string; iconKey?: string; }

@Component({
    selector: 'app-product-item',
    templateUrl: './product-item.component.html',
    styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent implements OnInit, OnChanges {

    @Input() data;

    actions: ActionItem[] = [];
    showDirectAreas: boolean = true;

    constructor(private policyService: PolicyService,
                private authService: AuthService,
                private router: Router) {}

    ngOnInit() {
        if (this.authService.isLogged()) {
            this.showDirectAreas = this.authService.getSelectedEntity() === 'ONLYGAL';
        }
        this.buildActions();
    }

    ngOnChanges() {
        this.buildActions();
    }

    getBackgroundColor(): string {
        if (undefined !== this.data) {
            return this.data.suspended ? 'background-red' : 'background-blue';
        }
        return 'background-blue';
    }

    private getNumber(): string {
        return this.data && this.data.number ? this.data.number.toString() : '';
    }

    private greatherThan(): boolean {
        if (undefined !== this.data && this.data.number) {
            return Number(this.data.number) > 10000000;
        }
        return false;
    }

    private onGetContractFile(): void {
        this.policyService.getContractFile(this.data.id);
    }

    private buildActions(): void {
        if (!this.data) { this.actions = []; return; }
        const num = this.getNumber();

        this.actions = [
            {
                label: 'Abrir un parte',
                icon: 'plus',
                action: () => this.router.navigate(['/events/register', num]),
                visible: !this.data.suspended && this.showDirectAreas
            },
            {
                label: 'Consultar un expediente',
                icon: 'file',
                action: () => this.router.navigate(['/expedientes'], { queryParams: { policy: num } })
            },
            {
                label: 'Descargar el PDF del contrato',
                icon: 'file-pdf',
                action: () => this.onGetContractFile(),
                visible: this.data.isTaker === true && this.greatherThan()
            },
            {
                label: 'Modificar o ampliar la cobertura',
                icon: 'file',
                action: () => this.router.navigate(['/hire/extend', num]),
                visible: this.data.isTaker === true && this.data.isEditable === true
            }
        ];
    }

    iconForCard(card: CardIcon): string {
        const base = 'resources/assets/images/main-page/';
        const key = ((card && (card.branchType || card.iconKey)) || '').toLowerCase().trim();
        const fileMap: { [k: string]: string } = {
            legal:        'onlygal-abogado-365.svg',
            abogado:      'onlygal-abogado-365.svg',
            lawyer:       'onlygal-abogado-365.svg',
            travel:       'onlygal-asistencia-viaje.svg',
            viaje:        'onlygal-asistencia-viaje.svg',
            trip:         'onlygal-asistencia-viaje.svg',
            compraventa:  'onlygal-compraventa-asegurada.svg',
            home:         'onlygal-compraventa-asegurada.svg',
            vivienda:     'onlygal-compraventa-asegurada.svg',
            inmueble:     'onlygal-compraventa-asegurada.svg',
            car:          'car.svg',
            coche:        'car.svg',
            vehiculo:     'car.svg'
        };
        let file = 'bag-2.svg';
        for (const k of Object.keys(fileMap)) {
            if (key.indexOf(k) !== -1) { file = fileMap[k]; break; }
        }
        return base + file;
    }
}
